import { useMemo, useState } from 'react';
import { AccommodationsConsolePropertiesQuery, useAccommodationsConsolePropertiesQuery } from '@graphql/generated';
import { AccommodationPlaces, AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';

interface UseAccommodationsConsoleListingsArgs {
  state: AccommodationsConsoleState;
}

export const useRegionalHotels = (args: UseAccommodationsConsoleListingsArgs, accommodationPlaces?: AccommodationPlaces) => {
  const { state } = args;

  const [cachedListings, setCachedListings] = useState<NonNullable<AccommodationsConsolePropertiesQuery['searchAccommodationProperties']>['properties']>([]);

  const { data, loading: isFetchingListings, error } = useAccommodationsConsolePropertiesQuery({
    variables: {
      payload: {
        circularRegionSearch: state.circularRegionSearch
      }
    },
    batchMode: 'off',
    onCompleted: data => {
      if (data?.searchAccommodationProperties?.properties) {
        setCachedListings(data.searchAccommodationProperties.properties);
      }
    },
    skip: !state.circularRegionSearch.latitude && !state.circularRegionSearch.longitude
  });

  const listingsWithCouplePicks = useMemo(() => {
    return (
      data?.searchAccommodationProperties?.properties?.map(listing => ({
        ...listing,
        isPickedByCouple: accommodationPlaces?.some(place => place.joyPlaceId === listing.id)
      })) || []
    );
  }, [accommodationPlaces, data?.searchAccommodationProperties?.properties]);

  return {
    /**
     * Can be used to retain maps points while loading new data
     */
    cachedListings,
    listings: listingsWithCouplePicks,
    isFetchingListings,
    error
  };
};
